import { Box, Typography } from '@mui/material';
import QRCodeData from './qrCodeData';

const styles = `
  .portal-qr-print-sheet {
    background: #fff;
    color: #000;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 16px;
  }

  .portal-qr-print-heading {
    display: none;
  }

  .portal-qr-print-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .portal-qr-print-card {
    background: #fff;
    color: #000;
    border: 1px solid #d6d6d6;
    border-radius: 8px;
    padding: 12px;
    text-align: center;
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .portal-qr-print-code {
    width: 120px;
    height: 120px;
    margin: 0 auto 8px;
  }

  .portal-qr-print-code svg {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media (min-width: 600px) {
    .portal-qr-print-grid {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }

    .portal-qr-print-code {
      width: 130px;
      height: 130px;
    }
  }

  @media (min-width: 900px) {
    .portal-qr-print-grid {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }

  @media print {
    @page {
      margin: 10mm;
    }

    html,
    body {
      background: #fff !important;
    }

    body * {
      visibility: hidden !important;
    }

    .portal-qr-print-sheet,
    .portal-qr-print-sheet * {
      visibility: visible !important;
    }

    .portal-qr-print-sheet {
      display: block !important;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      margin: 0;
      padding: 0;
      border: 0;
      border-radius: 0;
      color: #000 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .portal-qr-print-heading {
      display: block !important;
      margin-bottom: 5mm;
    }

    .portal-qr-print-heading * {
      color: #000 !important;
    }

    .portal-qr-print-group {
      margin: 0 0 5mm;
    }

    .portal-qr-print-group-heading {
      break-after: avoid;
      page-break-after: avoid;
      margin: 0 0 3mm !important;
      color: #000 !important;
      font-size: 13pt !important;
      font-weight: 700 !important;
    }

    .portal-qr-print-grid {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 5mm !important;
    }

    .portal-qr-print-card {
      break-inside: avoid;
      page-break-inside: avoid;
      padding: 3mm !important;
      border: 1px solid #000 !important;
      border-radius: 0 !important;
      color: #000 !important;
      background: #fff !important;
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    .portal-qr-print-code {
      width: 34mm !important;
      height: 34mm !important;
      margin: 0 auto 2mm !important;
    }

    .portal-qr-print-label {
      margin-bottom: 2mm !important;
      color: #000 !important;
      font-size: 18pt !important;
      font-weight: 700 !important;
      line-height: 1.1 !important;
      overflow-wrap: anywhere;
    }

    .portal-qr-print-caption {
      color: #000 !important;
      font-size: 8pt !important;
      line-height: 1.2 !important;
    }

    .no-print {
      display: none !important;
    }
  }
`;

const PrintableQRCodes = ({ title, subtitle, groups = [] }) => (
  <>
    <style>{styles}</style>
    <Box className="portal-qr-print-sheet">
      <Box className="portal-qr-print-heading">
        <Typography variant="h5" fontWeight="bold">
          {title}
        </Typography>
        {subtitle && <Typography variant="body2">{subtitle}</Typography>}
      </Box>

      {groups.map((group) => (
        <Box key={group.key} className="portal-qr-print-group" mb={3}>
          {group.heading && (
            <Typography
              className="portal-qr-print-group-heading"
              variant="subtitle1"
              fontWeight={700}
              mb={1.5}>
              {group.heading}
            </Typography>
          )}

          <Box className="portal-qr-print-grid">
            {group.items.map((item) => (
              <Box key={item.key} className="portal-qr-print-card">
                <Typography
                  className="portal-qr-print-label"
                  variant="subtitle1"
                  fontWeight={700}
                  mb={1}
                  sx={{ overflowWrap: 'anywhere' }}>
                  {item.label}
                </Typography>
                <Box className="portal-qr-print-code">
                  <QRCodeData
                    value={item.value}
                    style={{ display: 'block', width: '100%', height: '100%' }}
                  />
                </Box>
                {item.caption && (
                  <Typography
                    className="portal-qr-print-caption"
                    variant="caption"
                    display="block"
                    sx={{ color: '#555' }}>
                    {item.caption}
                  </Typography>
                )}
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  </>
);

export default PrintableQRCodes;
